module.exports = __webpack_public_path__ + "static/media/top_banner_8.dbbbe477.png";